import React from 'react';
import  {
    AUtableCell, 
    AUtableRow, 
} from '@gov.au/table';
import PropTypes from 'prop-types';

/*
 * RepeatingSummaryRow
 *
 * @param  {string}    id                  - id of the object in the row
 * @param  {string}    name                - name of the object in the row
 * @param  {array}     tableHeader         - table headers 
 * @param  {object}    tableBody           - table rows
 * @param  {function}  editUserCallback    - function for editing object in the row
 * @param  {function}  removeUserCallback  - function for removing object from data
 * @param  {string}    rowSpan             - number of rows to span
 * @param  {string}    className           - custom classname for the row
 */
export const RepeatingSummaryRow = ({ id, name, tableHeader, tableRowData, editUserCallback, removeUserCallback, rowSpan, className }) => {
    const generateTableCells = () => {
        return (
            tableHeader.map((tableHeaderItem, key) => {
                let questionValue = null;

                for(let index = 0; index < Object.keys(tableRowData).length; index++) {
                    const currentQuestion = Object.values(tableRowData)[index];
                    if(tableHeaderItem.key === currentQuestion.id) {
                        let value = currentQuestion.answer.value;
                        if (currentQuestion.type === 'checkbox') {
                            value = '';
                            currentQuestion.answer.checkboxValues.forEach(checkboxValue => {
                                if (value === '') {
                                    value = checkboxValue;
                                } else {
                                    value += ", " + checkboxValue;
                                }
                            }); 
                        }
                        questionValue = value
                    }
                }

                if (tableHeaderItem.key === "id" || tableHeaderItem.key === "name") {
                    return null
                }
                
                if (questionValue) {
                    return (
                        <td
                            className="au-table__cell"
                            key={tableHeaderItem + key}
                            rowSpan={tableHeader.extendRow ? rowSpan : "1"}>
                            {questionValue}
                        </td>
                    )
                }

                return (
                    <td
                        className="au-table__cell"
                        key={tableHeaderItem + key}
                        rowSpan={tableHeader.extendRow ? rowSpan : "1"}>
                        
                    </td>
                )
            })
        )
    }

    return (
        <AUtableRow
            className={className}>
            <td 
                className="au-table__cell"
                key={"name-" + name}
                rowSpan={tableHeader.find(element => element.key === "name").extendRow ? rowSpan : "1"}>
                <button className="faux-link" onClick={(e) => editUserCallback(id, e)}>
                    {name}
                </button>
            </td>
            <td
                className="au-table__cell"
                key={"id-" + id}
                rowSpan={tableHeader.find(element => element.key === "id").extendRow ? rowSpan : "1"}>
                {id}
            </td>
            {generateTableCells()}
            {removeUserCallback !== undefined &&
            <td
                className="au-table__cell"
                key={"remove-" + id}
                rowSpan={tableHeader.find(element => element.key === "name").extendRow ? rowSpan : "1"}>
                <button className="faux-link" onClick={(e) => removeUserCallback(e, id, name)}>
                    Remove
                </button>
            </td>}
        </AUtableRow>
    )
};

RepeatingSummaryRow.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    tableHeader: PropTypes.array.isRequired,
    tableRowData: PropTypes.object.isRequired,
    editUserCallback: PropTypes.func,
    removeUserCallback: PropTypes.func,
    rowSpan: PropTypes.number,
    className: PropTypes.string
};

/*
 * RepeatingSummarySubRow
 *
 * @param  {array}   tableHeader     - table headers 
 * @param  {object}  tableBody       - table rows
 * @param  {string}  className       - custom className for subrow
 */
export const RepeatingSummarySubRow = ({ tableHeader, tableRowData, className }) => {
    const generateTableCells = () => {
        return (
            tableRowData.map((question, key) => {
                if(tableHeader.filter((header) => header.key === question.id).length){
                    let value = question.value;
                    if (question.type === 'checkbox') {
                        value = '';
                        question.value.forEach(checkboxValue => {
                            if (value === '') {
                                value = checkboxValue;
                            } else {
                                value += ", " + checkboxValue;
                            }
                        });
                    }
                    return (
                        <AUtableCell type="text" key={question.id} data={value} />
                    )
                }
            })
        )
    }

    return (
        <tr className={className}>
            {generateTableCells()}
        </tr>
    )
};

RepeatingSummarySubRow.propTypes = {
    tableHeader: PropTypes.array.isRequired,
    tableRowData: PropTypes.array.isRequired,
    className: PropTypes.string
};

